import React, { useEffect, useState } from 'react';
import { Wrapper, Navigation, Item, IconWrapper } from './styled';
import { Icon } from '@app/src/common/Icon';
import { navConfig } from '@app/src/utils/categories';
import { COLORS } from '@app/src/ui';
import { isClientEnv } from '@app/src/utils/validations';
import { useHistory } from 'react-router-dom';

interface Props {
  className?: string;
  itemInicio?: boolean;
  navRef?: any;
  handleClick?: Function;
}

const isClient = isClientEnv();

export const NavBar: React.FC<Props> = ({
  className,
  itemInicio,
  navRef,
  handleClick
}) => {
  const history = useHistory();
  const milestones = {};
  let currentSection: string = '';
  const [ active, setActive ] = useState('');

  useEffect(() => {
    const isHomeView: boolean = history.location.pathname === '/';
    if (isClient && isHomeView) {
      window.addEventListener('load', handleLoad);
      window.addEventListener('scroll', handleScroll);
      setElementsByScrolling();
      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('load', handleLoad);
      }
    }
  });

  const setElementsByScrolling = (): void => {
    const arrMilestones = document.querySelectorAll('[data-scroll]');
    for (let i=0; i < arrMilestones.length; i++) {
      let dataScroll = arrMilestones[i].getAttribute('data-scroll');
      milestones[dataScroll] = arrMilestones[i];
    }
  };

  const handleLoad = () => {
    let id = window.location.hash;
    if (id) {
      id = id.replace('#','');
      const newPosition = getOffsetTop(id);
      window.scroll({top: newPosition, behavior:'smooth' })
    }
  };

  const handleScroll = (): void => {
    setSectionCurrentActive();
  };

  const setSectionCurrentActive = (): void => {
    if (window.pageYOffset < getOffsetTop('inmueble')) {
      currentSection = 'inicio';
    }
    if ( (window.pageYOffset >= getOffsetTop('inmueble'))  && (window.pageYOffset < getOffsetTop('vehiculo'))) {
      currentSection = 'inmueble';
    }
    if (window.pageYOffset >= (getOffsetTop('vehiculo')) && window.pageYOffset < getOffsetTop('empleo')) {
      currentSection = 'vehiculo';
    }
    if (window.pageYOffset >= getOffsetTop('empleo') && window.pageYOffset < getOffsetTop('educacion')) {
      currentSection = 'empleo';
    }
    if (window.pageYOffset >= getOffsetTop('educacion') && window.pageYOffset < getOffsetTop('oportunidad')) {
      currentSection = 'educacion';
    }
    if (window.pageYOffset >= getOffsetTop('oportunidad')) {
      currentSection = 'oportunidad';
    }
    if (currentSection !== active) {
      setActive(currentSection);
    }
  };

  const getOffsetTop = (section:string): number => {
    return milestones[section]['offsetTop'];
  };

  handleClick = (e) => {
    if (isClient) {
      e.preventDefault();
      const element = e.currentTarget;
      const id = element.hash.replace('#','');
      pushDatalayer(element.textContent, id);
      if (window.location.pathname === '/') {
        window.scroll({top: getOffsetTop(id), behavior:'smooth' })
        history.push(element.hash);
      } else {
        window.location.href = `${window.location.origin}/${element.hash}`;
      }
    }
  }

  const pushDatalayer = (service:string, alias:string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'MenuClasificados',
        'eventAction': service,
        'eventLabel': alias,
        'eventValue': 1
      })
    }
  }

  return (
    <React.Fragment>
      <Wrapper className={className} ref={navRef}>
        <Navigation>
          { itemInicio &&
            <Item key={0}>
              <IconWrapper  onClick={(e)=>handleClick(e)} href={'#inicio'}>
                <Icon data-name="icon-newspaper" width="25" height="25" fill={COLORS.BLACK} />
                <span>Inicio</span>
              </IconWrapper>
            </Item>
          }
          {
            navConfig.map((item, index) =>
              <Item key={index + 1} active={active === item.alias} background={item.color}>
                <IconWrapper onClick={e=>handleClick(e)} href={`#${item.alias}`}>
                  <Icon data-name={item.icon} width="25" height="25" fill={COLORS.BLACK} />
                  <span>{item.text}</span>
                </IconWrapper>
              </Item>
            )
          }
        </Navigation>
      </Wrapper>
    </React.Fragment>
  );
};

NavBar.displayName = 'NavBar';
